import { defineMessages } from 'react-intl';

export default defineMessages({
  loading: {
    id: 'sentinel.components.spinner.loading',
    description: 'Text displayed while something is being loaded',
    defaultMessage: 'Loading...',
  },
});



// WEBPACK FOOTER //
// ./src/components/Spinner/messages.js